module.exports = __webpack_public_path__ + "static/img/eye2eye_tall.59d7c18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/about/images/eye2eye_tall.svg
// module id = 7v22
// module chunks = 1